<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">{{this.$t('base.associated')}}</h4>
        </div>
        <div class="card-body">
          <!-- 表头 -->
          <div class="table-head">
            <label class="form-label">{{this.$t('page.app-industry.Equipment')}}</label>
          </div>
          <!-- 表单内容 -->
          <div class="table-content" v-if="measureList.length">
            <div
              class="row table-content-list align-items-center mb-3"
              v-for="(list, index) in measureList"
              :key="index"
            >
              <div class="col-3">
                <RelationInstanceSelect
                  :value="list.value"
                  :disabled="list.type == 'edit'"
                  :placeholder="list.label"
                  @selectChanged="measureChanged($event, list, index)"
                ></RelationInstanceSelect>
              </div>
              <div class="col-1">
                <b-button
                  variant="primary"
                  size="sm"
                  @click="showMessageBox = index"
                >
                  {{this.$t('base.cancel_connect')}}
                </b-button>
                <MessageBox
                  v-if="showMessageBox == index"
                  :messageCont="this.$t('base.sure_cancel_connect')"
                  :messageIcon="'ri-error-warning-line'"
                  :iconStyle="{ fontSize: '14px', color: '#f06548' }"
                  @makeSure="confirmCancelMeasure(index, list)"
                  @makeClose="showMessageBox = null"
                ></MessageBox>
              </div>
            </div>
          </div>
          <!-- 点击添加关联设备 -->
          <div class="addButton">
            <b-button variant="primary" @click="addRelationMeasure()">
              {{this.$t('base.add_concact_device')}}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/default.scss";
import MessageBox from "@/components/common/MessageBox.vue";
import _ from "lodash";
import RelationInstanceSelect from "./RelationInstanceSelect";

export default {
  data() {
    return {
      showMessageBox: null,
      defaultMeasure: {
        type: "create",
        id: "",
        value: "",
        name: "",
        label: "",
        disabled: false,
      },
    };
  },
  emits: ["update:relationMeasureList"],
  props: {
    relationMeasureList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed:{
    measureList(){
        // console.log('list....', this.relationMeasureList)
        return _.cloneDeep(this.relationMeasureList)
    }
  },
  watch: {
  },
  methods: {
    /* 点击添加关联物实例 */
    addRelationMeasure() {
      this.measureList.push({ ...this.defaultMeasure });
      this.$emit("update:relationMeasureList", this.measureList);
    },
    /* 关联数据新增 */
    measureChanged(val, item, index) {
      // console.log('measureChanged....')
      if (!val) {
        /* 删除 */
        this.measureList[index].id = "";
        this.measureList[index].value = "";
        this.measureList[index].label = "";
        this.measureList[index].name = "";
        this.measureList[index].disabled = false;
      } else if (val) {
        /* 赋值 */
        this.measureList[index].id = val.id;
        this.measureList[index].value = val.id;
        this.measureList[index].label = val.name + "(" + val.root_sn + ")";
        this.measureList[index].name = val.name;
        this.measureList[index].root_sn = val.root_sn;
        this.measureList[index].disabled = true;
      }

      /* 变更options状态 */
      // var str = "";
      //
      // this.measureList.map((item) => {
      //   str += item.id;
      // });
      // this.options.map((items) => {
      //   if (str.indexOf(items.id) > -1) {
      //     items.disabled = true;
      //   } else if (!items.has_parent) {
      //     items.disabled = false;
      //   }
      // });
       this.$emit("update:relationMeasureList", this.measureList);

      //   for (let i = 0; i < this.measureList.length; i++) {
      //     for (let j = 0; j < this.options.length; j++) {
      //       if (this.measureList[i].id == this.options[j].id) {
      //         this.options[j].disabled = this.measureList[i].disabled;
      //       } else {
      //         this.options[j].disabled = this.options[j].has_parent;
      //       }
      //     }
      //   }
    },
    /* 确认取消关联 */
    confirmCancelMeasure(index, list) {
      this.measureList.splice(index, 1);
      this.showMessageBox = null;
      this.$emit("update:relationMeasureList", this.measureList);
      console.log('confirmCancelMeasure....', list)
      // this.options.forEach((rel) => {
      //   /* 取消关联后将当前选项的变为可选 */
      //   if (rel.id == list.id) {
      //     rel.disabled = false;
      //     rel.has_parent = false;
      //   }
      // });
    },
  },
  components: {
    // Multiselect,
    MessageBox,
    RelationInstanceSelect,
  },
};
</script>

<style scoped lang="scss"></style>
